import { t } from '@lingui/macro';

// lowercase, so we have case-insensitive search
export enum FiltersParams {
    bpmlowerbound = 'bpmlowerbound',
    bpmupperbound = 'bpmupperbound',
    genres = 'genres',
    instruments = 'instruments',
    keyquality = 'keyquality',
    keyrootnote = 'keyrootnote',
    orderby = 'orderby',
    orderbydirection = 'orderbydirection',
    tags = 'tags',
    textsearch = 'textsearch',
    type = 'type',
    sfxs = 'sfxs',
}

export const getDisplayableFiltersParams: () => {
    [key: string]: string;
} = () => ({
    [FiltersParams.instruments]: t`Instruments`,
    [FiltersParams.genres]: t`Genres`,
    [FiltersParams.type]: t`Types`,
    [FiltersParams.sfxs]: t`SFX`,
    [FiltersParams.tags]: t`Tags`,
    [FiltersParams.textsearch]: '', // no categories for text search
});

export enum NavigationParams {
    page = 'page',
    tab = 'tab',
}

export enum AudioConfigParams {
    autoPlay = 'autoplay',
}

export const Params = {
    ...NavigationParams,
    ...FiltersParams,
    ...AudioConfigParams,
};
